import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styles from "./index.module.css";
import { useOutsideClick } from "@/06-shared/lib/useOutsideClick";
export const PopupWindow = ({ name, children, onClose }) => {
    const modalRef = useOutsideClick(() => onClose());
    return (_jsx("div", { className: styles.background, children: _jsxs("div", { className: styles.popupWindow, ref: modalRef, children: [_jsxs("div", { className: styles.popupHead, children: [_jsx("p", { className: styles.popupName, children: name }), _jsx("p", { className: styles.popupClose, onClick: () => onClose(), children: "[x]" })] }), _jsx("div", { className: styles.popupBody, children: children })] }) }));
};
